import MoreMenuListButton from "@chemaxon/terminus-client/ui/components/more-menu/MoreMenuListButton";
import { Content } from "@chemaxon/design-system/color";
import Info from "@chemaxon/design-system/icons/Info";

export default function DetailsButton(props: Props) {
  return (
    <MoreMenuListButton
      onClick={props.onClick}
      icon={<Info />}
      color={Content.main}
      text="Details"
    />
  );
}

type Props = {
  onClick: () => void;
};
